(function(){
	"use strict";

	angular
		.module('pwc.controllers')
		.controller('PurchaseAuctionHouseReportController', PurchaseAuctionHouseReportController);

	PurchaseAuctionHouseReportController.$inject = ['$window', 'WineRepository', '$log', 'lodash', '$state'];

	function PurchaseAuctionHouseReportController($window, WineRepository, $log, lodash, $state){

		/* jshint validthis: true */
		var self = this;

		self.report = {
			loading: true,
			auctionHouses: [],
			groups: [],
			totals: {}
		};

		self.currentDate = $window.moment().format('MM/DD/YYYY');

		self.currentYear = $window.moment().format('YYYY');

		self.title = $state.current.data.title;

		self.printSettings = {
			"fontSize": 12,
			"style": "custom"
		};

		self.print = print;

		/** initialize */

		initialize();

		/** begin methods */

		function initialize(){

			WineRepository.all()
				.then(function(wineEntities){

					if (wineEntities.length > 0){

						self.report.tableHeaders = [
							'Wine',
							'Size',
							'Bottles In Cellar / Purchased / On Order',
							'Cost per bottle',
							'Value',
							'Gain&nbsp;/&nbsp;Loss'
						];

						var keyName = 'Auction House';
						var keyNamePlural = keyName + 's';

						// group by auction house
						lodash.forEach(wineEntities, function(wine) {
							var purchases = wine.getHistoryByCategory('auction');

							if (purchases.length > 0) {
								lodash.forEach(purchases, function(purchase) {
									// create array if doesn't exist yet
									if (! lodash.isArray(self.report.auctionHouses[purchase.source])) {
										self.report.auctionHouses[purchase.source] = [];
									}

									self.report.auctionHouses[purchase.source].push({
										wine: wine,
										purchase: purchase,
										auctionHouse: purchase.source // not necessary?
									});
								});
							}
						});

						// initialize totals
						var grandTotals = {
							bottlesInCellar: 0,
							bottlesPurchased: 0,
							bottlesOnOrder: 0,
							value: 0,
							groupCount: Object.keys(self.report.auctionHouses).length
						};

						lodash.forOwn(self.report.auctionHouses, function(auctionHouseObjects, group) {
							var wines = lodash.map(auctionHouseObjects, 'wine');

							var groupTotals = {
								bottlesInCellar: 0,
								bottlesPurchased: 0,
								bottlesOnOrder: 0,
								value: 0
							};

							groupTotals.bottlesInCellar = WineRepository.getTotalCellarBottleCount(wines);
							groupTotals.value = WineRepository.getCellarValue(wines);

							var formattedWines = [];

							lodash.forEach(wines, function(wine) {
								var varietal = (wine.varietal && wine.varietal.name) ? wine.varietal.name + ' ' : '';
								var category = (wine.category && wine.category.name) ? wine.category.name : '';
								var type = varietal + category;

								// add foreach purchase here.
								var purchases = wine.getHistoryByCategory('auction');

								var qtyOnOrder = wine.getOnOrderQty();
								groupTotals.bottlesOnOrder += qtyOnOrder;

								lodash.forEach(purchases, function(purchase) {
									var purchasePriceFloat = purchase.price;

									// it's important to note that this report will show a '-' for gain/loss when there
									// are no wines in the cellar
									var valueGainFormatted = wine.getRelativeGainPercentFormatted(purchasePriceFloat);
									var valueGainClass = wine.getValueGainClass(purchasePriceFloat);

									groupTotals.bottlesPurchased += purchase.qty;

									// data we want to display on a single wine record / report row
									formattedWines.push({
										name: wine.getFullName(),
										appelation: wine.getFullAppellation(),
										type: type,
										size: wine.bottleSize.name,
										qtyInCellar: wine.cellar.qty,
										qtyPurchased: purchase.qty,
										qtyOnOrder: qtyOnOrder,
										purchasePrice: $window.numeral(purchasePriceFloat).format('$0,0[.]00'),
										value: $window.numeral(wine.cellar.value).format('$0,0[.]00'),
										gain: valueGainFormatted,
										gainClass: valueGainClass
									});
								});
							});

							// group subtotal row
							self.report.groups.push({
								group: group,
								bottlesInCellar: groupTotals.bottlesInCellar,
								bottlesPurchased: groupTotals.bottlesPurchased,
								bottlesOnOrder: groupTotals.bottlesOnOrder,
								value: $window.numeral(groupTotals.value).format('$0,0[.]00'),
								wines: formattedWines
							});

							// update grand totals, adding in this group
							grandTotals.bottlesInCellar += groupTotals.bottlesInCellar;
							grandTotals.bottlesPurchased += groupTotals.bottlesPurchased;
							grandTotals.bottlesOnOrder += groupTotals.bottlesOnOrder;
							grandTotals.value += groupTotals.value;
						});

						// grand total row
						self.report.totals = [
							// 'Producer / Wine',
							'Total ' + keyNamePlural + ': ' + grandTotals.groupCount,
							// 'Size',
							null,
							// 'Bottles',
							grandTotals.bottlesInCellar + ' / ' + grandTotals.bottlesPurchased + ' / ' + grandTotals.bottlesOnOrder,
							// 'Average Cost',
							null,
							// 'Value',
							$window.numeral(grandTotals.value).format('$0,0[.]00'),
							// 'Gain / Loss'
							null
						];

						// hide loading
						self.report.loading = false;

						return true;
					}

					return false;

				}).catch(function(err){
				$log.debug('Error getting wines', err);
			});

		}

		function print(){
			return $window.print();
		}
	}

})();
